export enum ClassisManifestContentType {
  Text = 'conditional_plain_text',
  Image = 'conditional_image',
  Button = 'button',
  SubmitButton = 'submit_button2',
  Footer = 'smart_component_footer'
}
